import { EOgqlJobState, IOgqlJobResult } from '@opengov/ogql-types';
import { EQueryType, IReportConfiguration } from '@opengov/reporting-types';

import { chartActionCreators } from '../../../../reportExplorer/ReportVisualization/state';
import { summaryTableEffects } from '../../../../summaryTable/effects';
import { IReportLocale } from '../../../locale';
import { respondToVisualizationQuerySuccess } from '../reportQueryEffectResponders';

import { runV0Query } from './runQueries';
import { reportActionCreators } from '../../../report/state';
import { MuiToastTypes } from '../../../helpers/utils';
interface IVisualizationQuery {
  isStandardTemplate: boolean;
  lensId: string;
  queryId?: string;
  reportConfiguration: IReportConfiguration;
  reportMsgs: IReportLocale;
  templateId: string;
  useLargeScaleQueryLimit: boolean;
  useQueryService: boolean;
}

export const visualizationQuery = async ({
  isStandardTemplate,
  lensId,
  reportConfiguration,
  reportMsgs,
  templateId,
  useLargeScaleQueryLimit,
  useQueryService,
  queryId
}: IVisualizationQuery): Promise<IOgqlJobResult | undefined> => {
  return runV0Query({
    isStandardTemplate,
    lensId,
    queryType: EQueryType.visualizationQuery,
    reportId: reportConfiguration.reportId,
    queryId,
    templateId,
    body: isStandardTemplate ? { reportConfiguration } : reportConfiguration,
    useLargeScaleQueryLimit,
    useQueryService
  })
    .then((result) => {
      return handleVisualizationQueryResult(result, reportMsgs, reportConfiguration);
    })
    .then((result) => {
      if (result.state === EOgqlJobState.finished) {
        void summaryTableEffects.continueVisualizationQuery({
          result,
          reportConfiguration,
          reportMsgs,
          isStandardTemplate
        });
      }

      return result;
    })
    .catch((e) => {
      console.error(e);
      /*
       * If the user navigates to report (split('/')[3] is reportId place) and the query fails, we will show the toast.
       * but if the user navigates back to gallery and the query fails,
       * we don't want to show a toast indicating the failure.
       * This is a temporary solution until we have a better way to handle this.
       */
      if (window.location.pathname.split('/')[3]) {
        reportActionCreators.toggleMuiToast({
          type: MuiToastTypes.FAILURE,
          headerText: reportMsgs.query.failure.headerText,
          bodyText: reportMsgs.query.failure.bodyText
        });
      }
      return undefined;
    });
};

export const handleVisualizationQueryResult = (result: IOgqlJobResult, reportMsgs, reportConfiguration) => {
  switch (result.state) {
    case EOgqlJobState.finished: {
      // Setup chart state
      respondToVisualizationQuerySuccess(
        result.jobResult,
        chartActionCreators.setVisualizationResultAndReportConfiguration,
        reportConfiguration
      );
      return result;
    }
    case EOgqlJobState.failed: {
      reportActionCreators.toggleMuiToast({
        type: MuiToastTypes.FAILURE,
        headerText: reportMsgs.query.failure.headerText,
        bodyText: reportMsgs.query.failure.bodyText
      });
      return result;
    }
    // nothing to do .. we cancelled it
    case EOgqlJobState.cancelled:
    default:
      return result;
  }
};
